import * as React from "react";

const SvgPreloader = (props) => (
  <svg
    width={200}
    height={200}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#preloader_svg__a)">
      <circle
        cx={100}
        cy={100}
        r={85}
        transform="rotate(-180 100 100)"
        stroke="currentColor"
        strokeWidth={15}
      />
    </g>
    <g clipPath="url(#preloader_svg__b)">
      <circle cx={100} cy={100} r={90} stroke="currentColor" strokeWidth={15} />
    </g>
    <defs>
      <clipPath id="preloader_svg__a">
        <path
          fill="currentColor"
          transform="rotate(-180 100 100)"
          d="M0 0h100v100H0z"
        />
      </clipPath>
      <clipPath id="preloader_svg__b">
        <path fill="currentColor" d="M0 0h100v100H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPreloader;
